function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import AsyncStorage from "@react-native-async-storage/async-storage";
import * as Sentry from "@sentry/core";
import * as Device from "expo-device";
import * as LocalAuthentication from "expo-local-authentication";
import * as SecureStore from "expo-secure-store";
import Cookies from "js-cookie";
import omit from "lodash/omit";
import { Platform } from "react-native";
import { graphql } from "@oui/lib/src/graphql/tada";
import { APP_SLUG, environment, IS_PRODUCTION, REST_API_URL } from "../constants";
import { CurrentUserFragment, CurrentUserQuery } from "../hooks/useCurrentUser.query";
import { addBreadcrumb } from "./log";
import { clearAll } from "./mmkv";
export var LoginMutation = graphql("\n    mutation Login($email: String!, $password: String!) {\n      loginWithEmail(email: $email, password: $password) {\n        __typename\n        ... on BaseError {\n          message\n        }\n        ... on InvalidPasswordError {\n          message\n        }\n        ... on UserDisabledError {\n          message\n        }\n        ... on UserSession {\n          token {\n            expiresAt\n            value\n          }\n          user {\n            ...CurrentUser\n          }\n        }\n      }\n    }\n  ", [
    CurrentUserFragment
]);
var ReauthenticateMutation = graphql("\n  mutation Reauthenticate($email: String!, $password: String!) {\n    reauthenticate(email: $email, password: $password)\n  }\n");
function getSecureStoreCompatibleKey(key) {
    return key.replace(/[^\w\d\.\-\_]/g, '_');
}
function getTokenFromCookie(key) {
    var maybeStr = Cookies.get(key);
    if (maybeStr) {
        return JSON.parse(global.window.atob(maybeStr));
    }
    return null;
}
function maybeSimulateBiometricAuth() {
    return _maybeSimulateBiometricAuth.apply(this, arguments);
}
function _maybeSimulateBiometricAuth() {
    _maybeSimulateBiometricAuth = /**
 * iOS simulator doesn't fully implement the real behavior for
 * keychain/requireAuthentication items in SecureStore. This function serves as
 * a polyfill so that UX is the same on sim as it is on device
 * https://medium.com/@alx.gridnev/biometry-protected-entries-in-ios-keychain-6125e130e0d5
 */ _async_to_generator(function() {
        var _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = Platform.OS === 'ios' && !Device.isDevice;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        LocalAuthentication.isEnrolledAsync()
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!_tmp) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        LocalAuthentication.authenticateAsync()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _maybeSimulateBiometricAuth.apply(this, arguments);
}
var DEFAULT_AUTH_STORAGE = process.env.NEXT_PUBLIC_API_CLIENT ? {
    getItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    getTokenFromCookie(key)
                ];
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }(),
    hasItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            DEFAULT_AUTH_STORAGE.getItem(key)
                        ];
                    case 1:
                        return [
                            2,
                            !!_state.sent()
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }(),
    setItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key, value) {
            return _ts_generator(this, function(_state) {
                Cookies.set(key, global.window.btoa(JSON.stringify(value)), {
                    secure: environment !== 'development'
                });
                return [
                    2
                ];
            });
        });
        return function(key, value) {
            return _ref.apply(this, arguments);
        };
    }(),
    removeItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            return _ts_generator(this, function(_state) {
                Cookies.remove(key);
                return [
                    2
                ];
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }()
} : Platform.OS === 'web' ? {
    getItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            var value;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AsyncStorage.getItem(key)
                        ];
                    case 1:
                        value = _state.sent();
                        return [
                            2,
                            value ? JSON.parse(value) : null
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }(),
    hasItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            DEFAULT_AUTH_STORAGE.getItem(key)
                        ];
                    case 1:
                        return [
                            2,
                            !!_state.sent()
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }(),
    setItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key, value) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AsyncStorage.setItem(key, JSON.stringify(value))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(key, value) {
            return _ref.apply(this, arguments);
        };
    }(),
    removeItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            AsyncStorage.removeItem(key)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }()
} : {
    getItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            var value;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            maybeSimulateBiometricAuth()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            SecureStore.getItemAsync(getSecureStoreCompatibleKey(key))
                        ];
                    case 2:
                        value = _state.sent();
                        if (value) {
                            return [
                                2,
                                JSON.parse(value)
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }(),
    hasItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            var value;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            SecureStore.getItemAsync(getSecureStoreCompatibleKey(key + 'present'))
                        ];
                    case 1:
                        value = _state.sent();
                        return [
                            2,
                            !!value
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }(),
    setItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key, token) {
            var value;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!token) {
                            return [
                                2,
                                DEFAULT_AUTH_STORAGE.removeItem(key)
                            ];
                        }
                        value = JSON.stringify(token);
                        if (value.length > 2048 - 100) {
                            Sentry.captureMessage('Auth SecureStore usage close to length limit', {
                                level: 'warning',
                                extra: {
                                    length: value.length
                                }
                            });
                        }
                        return [
                            4,
                            maybeSimulateBiometricAuth()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            SecureStore.setItemAsync(getSecureStoreCompatibleKey(key + 'present'), 'true', {
                                keychainAccessible: SecureStore.AFTER_FIRST_UNLOCK_THIS_DEVICE_ONLY
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            SecureStore.setItemAsync(getSecureStoreCompatibleKey(key), value, {
                                keychainAccessible: SecureStore.WHEN_PASSCODE_SET_THIS_DEVICE_ONLY,
                                requireAuthentication: true
                            })
                        ];
                }
            });
        });
        return function(key, token) {
            return _ref.apply(this, arguments);
        };
    }(),
    removeItem: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                SecureStore.deleteItemAsync(getSecureStoreCompatibleKey(key)),
                                SecureStore.deleteItemAsync(getSecureStoreCompatibleKey(key + 'present'))
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(key) {
            return _ref.apply(this, arguments);
        };
    }()
};
var USER_SESSION_TOKEN_STORAGE_KEY = process.env.NEXT_PUBLIC_API_CLIENT ? "".concat(process.env.NEXT_PUBLIC_API_CLIENT, ".session") : 'ouitoken';
var sessionTimeout;
var _initialized = /*#__PURE__*/ new WeakMap(), _apollo = /*#__PURE__*/ new WeakMap(), _callbacks = /*#__PURE__*/ new WeakMap(), _ouiToken = /*#__PURE__*/ new WeakMap(), _lastSeen = /*#__PURE__*/ new WeakMap(), _authStorage = /*#__PURE__*/ new WeakMap();
/**
 * @summary App AuthClient
 *
 * Initializes the local authentication system. Stores the auth token locally
 * using a secure storage mechanism when available. If not available (i.e.
 * Web), the token returned from the server should be short lived.
 *
 * The current user's information is also loaded. That data can be cached for
 * offline initialization using apollo's cache.
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-155}
 */ var AuthClient = /*#__PURE__*/ function() {
    "use strict";
    function AuthClient() {
        _class_call_check(this, AuthClient);
        _class_private_field_init(this, _initialized, {
            writable: true,
            value: false
        });
        _class_private_field_init(this, _apollo, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _callbacks, {
            writable: true,
            value: []
        });
        _class_private_field_init(this, _ouiToken, {
            writable: true,
            value: null
        });
        _class_private_field_init(this, _lastSeen, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _authStorage, {
            writable: true,
            value: DEFAULT_AUTH_STORAGE
        });
    }
    _create_class(AuthClient, [
        {
            /** @nosync */ key: "isInitialized",
            value: function isInitialized() {
                return _class_private_field_get(this, _initialized);
            }
        },
        {
            /** @nosync */ key: "setAuthApolloClient",
            value: function setAuthApolloClient(apolloClient) {
                _class_private_field_set(this, _apollo, apolloClient);
            }
        },
        {
            key: "setAuthStorage",
            value: function setAuthStorage(authStorage) {
                _class_private_field_set(this, _authStorage, authStorage);
            }
        },
        {
            key: "init",
            value: /**
   * Loads the current authentication state if starting from a cold-start
   * @nosync
   */ function init(apolloClient) {
                var forceReauth = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).forceReauth;
                var _this = this;
                return _async_to_generator(function() {
                    var canReauthenticate, _ref, _tmp, isLoggedIn;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_class_private_field_get(_this, _initialized)) {
                                    return [
                                        2,
                                        Promise.resolve({
                                            isLoggedIn: _this.getIsLoggedIn(),
                                            reauthenticate: !_class_private_field_get(_this, _ouiToken)
                                        })
                                    ];
                                }
                                _this.setAuthApolloClient(apolloClient);
                                return [
                                    4,
                                    _this.isTokenPersisted()
                                ];
                            case 1:
                                canReauthenticate = _state.sent();
                                if (!(canReauthenticate && Platform.OS === 'web' && !forceReauth)) return [
                                    3,
                                    4
                                ];
                                _tmp = [
                                    _this,
                                    _ouiToken
                                ];
                                return [
                                    4,
                                    _class_private_field_get(_this, _authStorage).getItem(USER_SESSION_TOKEN_STORAGE_KEY)
                                ];
                            case 2:
                                _class_private_field_set.apply(void 0, _tmp.concat([
                                    (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : null
                                ]));
                                return [
                                    4,
                                    _this.startSessionTimeoutTimer()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _class_private_field_set(_this, _initialized, true);
                                isLoggedIn = !!_class_private_field_get(_this, _ouiToken);
                                _this.emitAuthStateChanged(isLoggedIn);
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'init',
                                    data: {
                                        isLoggedIn: isLoggedIn,
                                        canReauthenticate: canReauthenticate
                                    }
                                });
                                return [
                                    2,
                                    {
                                        isLoggedIn: isLoggedIn,
                                        reauthenticate: !_class_private_field_get(_this, _ouiToken) && canReauthenticate
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLastSeen",
            value: function getLastSeen() {
                return _class_private_field_get(this, _lastSeen);
            }
        },
        {
            key: "setLastSeen",
            value: function setLastSeen() {
                var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                _class_private_field_set(this, _lastSeen, time);
            }
        },
        {
            key: "DANGEROUS_overrideOuiToken",
            value: /** @nosync */ function DANGEROUS_overrideOuiToken(token) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _class_private_field_set(_this, _initialized, true);
                                return [
                                    4,
                                    _this.cacheOuiToken(token)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "DANGEROUS_setInitialized",
            value: /** @nosync */ function DANGEROUS_setInitialized(init) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _class_private_field_set(_this, _initialized, init);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** @nosync */ key: "onAuthStateChanged",
            value: function onAuthStateChanged(callback) {
                var _this = this;
                _class_private_field_get(this, _callbacks).push(callback);
                return function() {
                    _class_private_field_set(_this, _callbacks, _class_private_field_get(_this, _callbacks).filter(function(c) {
                        return c !== callback;
                    }));
                };
            }
        },
        {
            /** @nosync */ key: "getAuthorizationHeader",
            value: function getAuthorizationHeader() {
                var authToken = this.getAuthToken();
                return authToken ? "Bearer ".concat(authToken) : undefined;
            }
        },
        {
            /** @nosync */ key: "getIsLoggedIn",
            value: function getIsLoggedIn() {
                return !!this.getOuiToken();
            }
        },
        {
            key: "signOut",
            value: /** @nosync */ function signOut() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'sign-out'
                                });
                                return [
                                    4,
                                    _this.clearStorage()
                                ];
                            case 1:
                                _state.sent();
                                _class_private_field_set(_this, _ouiToken, null);
                                clearTimeout(sessionTimeout);
                                return [
                                    4,
                                    _class_private_field_get(_this, _authStorage).removeItem(USER_SESSION_TOKEN_STORAGE_KEY)
                                ];
                            case 2:
                                _state.sent();
                                _this.emitAuthStateChanged(false);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "login",
            value: /** @nosync */ function login(email, password) {
                var _this = this;
                return _async_to_generator(function() {
                    var _response_data, _response_data1, _response_data2, response, _response_data3;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // just in case some data from the last user was somehow still persisted, we proactively clear
                                // storage before signing in a new user so there is no chance of showing a user the wrong user's data
                                return [
                                    4,
                                    _this.clearStorage()
                                ];
                            case 1:
                                _state.sent();
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'login'
                                });
                                return [
                                    4,
                                    _class_private_field_get(_this, _apollo).mutate({
                                        mutation: LoginMutation,
                                        variables: {
                                            email: email,
                                            password: password
                                        },
                                        context: {
                                            headers: {
                                                'X-Oui-Session-Duration': APP_SLUG === 'oui-aviva-staff' && !IS_PRODUCTION ? 60 * 60 * 24 * 30 : undefined
                                            }
                                        }
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                if (((_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.loginWithEmail.__typename) !== 'UserSession') {
                                    ;
                                    throw new Error((_response_data3 = response.data) === null || _response_data3 === void 0 ? void 0 : _response_data3.loginWithEmail.message);
                                }
                                return [
                                    4,
                                    _this.cacheOuiToken(((_response_data1 = response.data) === null || _response_data1 === void 0 ? void 0 : _response_data1.loginWithEmail.token) ? omit((_response_data2 = response.data) === null || _response_data2 === void 0 ? void 0 : _response_data2.loginWithEmail.token, '__typename') : null)
                                ];
                            case 3:
                                _state.sent();
                                _this.emitAuthStateChanged(true);
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'login-success'
                                });
                                _this.setLastSeen();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isTokenPersisted",
            value: function isTokenPersisted() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        return [
                            2,
                            _class_private_field_get(_this, _authStorage).hasItem(USER_SESSION_TOKEN_STORAGE_KEY)
                        ];
                    });
                })();
            }
        },
        {
            key: "useBiometricAuthentication",
            value: function useBiometricAuthentication() {
                var _this = this;
                return _async_to_generator(function() {
                    var token;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.isTokenPersisted()
                                ];
                            case 1:
                                if (!_state.sent()) return [
                                    3,
                                    4
                                ];
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'reauthenticate'
                                });
                                return [
                                    4,
                                    _class_private_field_get(_this, _authStorage).getItem(USER_SESSION_TOKEN_STORAGE_KEY)
                                ];
                            case 2:
                                token = _state.sent();
                                if (!token) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.cacheOuiToken(token !== null && token !== void 0 ? token : null)
                                ];
                            case 3:
                                _state.sent();
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'reauthenticate-success'
                                });
                                _this.emitAuthStateChanged(true);
                                _this.setLastSeen();
                                return [
                                    2,
                                    true
                                ];
                            case 4:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reauthenticate",
            value: /** @nosync */ function reauthenticate(email, password) {
                var _this = this;
                return _async_to_generator(function() {
                    var user, _tmp, _response_data, _response_data1, _response_data2, response, _response_data3;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!email) return [
                                    3,
                                    1
                                ];
                                _tmp = {
                                    email: email
                                };
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.getCurrentUserEmail()
                                ];
                            case 2:
                                _tmp = _state.sent() || {
                                    email: ''
                                };
                                _state.label = 3;
                            case 3:
                                user = _tmp;
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'reauthenticate'
                                });
                                if (!_class_private_field_get(_this, _ouiToken)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _class_private_field_get(_this, _apollo).mutate({
                                        mutation: ReauthenticateMutation,
                                        variables: {
                                            email: user.email,
                                            password: password
                                        }
                                    })
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 5:
                                return [
                                    4,
                                    _class_private_field_get(_this, _apollo).mutate({
                                        mutation: LoginMutation,
                                        variables: {
                                            email: user.email,
                                            password: password
                                        }
                                    })
                                ];
                            case 6:
                                response = _state.sent();
                                if (((_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.loginWithEmail.__typename) !== 'UserSession') {
                                    ;
                                    throw new Error((_response_data3 = response.data) === null || _response_data3 === void 0 ? void 0 : _response_data3.loginWithEmail.message);
                                }
                                return [
                                    4,
                                    _this.cacheOuiToken(((_response_data1 = response.data) === null || _response_data1 === void 0 ? void 0 : _response_data1.loginWithEmail.token) ? omit((_response_data2 = response.data) === null || _response_data2 === void 0 ? void 0 : _response_data2.loginWithEmail.token, '__typename') : null)
                                ];
                            case 7:
                                _state.sent();
                                _this.emitAuthStateChanged(true);
                                _state.label = 8;
                            case 8:
                                addBreadcrumb({
                                    category: 'auth',
                                    message: 'reauthenticate-success'
                                });
                                _this.setLastSeen();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "enableBiometricAuthentication",
            value: function enableBiometricAuthentication() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!SecureStore.canUseBiometricAuthentication()) {
                                    throw new Error('Platform does not support persisting token');
                                }
                                if (!_class_private_field_get(_this, _ouiToken)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _class_private_field_get(_this, _authStorage).setItem(USER_SESSION_TOKEN_STORAGE_KEY, _class_private_field_get(_this, _ouiToken))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "disableBiometricAuthentication",
            value: function disableBiometricAuthentication() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!SecureStore.canUseBiometricAuthentication()) {
                                    throw new Error('Platform does not support persisting token');
                                }
                                return [
                                    4,
                                    _class_private_field_get(_this, _authStorage).removeItem(USER_SESSION_TOKEN_STORAGE_KEY)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOuiToken",
            value: function getOuiToken() {
                return _class_private_field_get(this, _ouiToken);
            }
        },
        {
            key: "emitAuthStateChanged",
            value: function emitAuthStateChanged(isLoggedIn) {
                _class_private_field_get(this, _callbacks).map(function(cb) {
                    return cb(isLoggedIn);
                });
            }
        },
        {
            key: "clearStorage",
            value: function clearStorage() {
                var _this = this;
                return _async_to_generator(function() {
                    var _$_class_private_field_get;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_$_class_private_field_get = _class_private_field_get(_this, _apollo)) === null || _$_class_private_field_get === void 0 ? void 0 : _$_class_private_field_get.clearStore()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    Promise.all([
                                        clearAll(),
                                        AsyncStorage.clear()
                                    ]).catch(function(e) {
                                        // if we can't clear it's not worth stopping the entire process
                                        // this specific error message happens when we try to clear async storage but there are no entries
                                        if (!e.toString().startsWith('Error: Failed to delete storage directory')) {
                                            Sentry.captureException(e);
                                        }
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAuthToken",
            value: /** @nosync */ function getAuthToken() {
                var _this_getOuiToken;
                var _this_getOuiToken_value;
                return (_this_getOuiToken_value = (_this_getOuiToken = this.getOuiToken()) === null || _this_getOuiToken === void 0 ? void 0 : _this_getOuiToken.value) !== null && _this_getOuiToken_value !== void 0 ? _this_getOuiToken_value : null;
            }
        },
        {
            key: "getCurrentUserEmail",
            value: function getCurrentUserEmail() {
                var _this = this;
                return _async_to_generator(function() {
                    var _user_data_user, _tmp, user, email;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = !_class_private_field_get(_this, _ouiToken);
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.isTokenPersisted()
                                ];
                            case 1:
                                _tmp = !_state.sent();
                                _state.label = 2;
                            case 2:
                                if (_tmp) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    _class_private_field_get(_this, _apollo).query({
                                        query: CurrentUserQuery,
                                        fetchPolicy: 'cache-only'
                                    })
                                ];
                            case 3:
                                user = _state.sent();
                                email = (_user_data_user = user.data.user) === null || _user_data_user === void 0 ? void 0 : _user_data_user.email;
                                return [
                                    2,
                                    email ? {
                                        email: email
                                    } : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cacheOuiToken",
            value: function cacheOuiToken(token) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _class_private_field_set(_this, _ouiToken, token);
                                if (!!token) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _class_private_field_get(_this, _authStorage).removeItem(USER_SESSION_TOKEN_STORAGE_KEY)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.startSessionTimeoutTimer()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "startSessionTimeoutTimer",
            value: function startSessionTimeoutTimer() {
                var _this = this;
                return _async_to_generator(function() {
                    var cacheOuiToken, getOuiToken, getMsToTokenExpiry;
                    function runSessionTimeout() {
                        var ms = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getMsToTokenExpiry();
                        sessionTimeout = setTimeout(function() {
                            var _getOuiToken;
                            fetch("".concat(REST_API_URL, "/auth/token"), {
                                headers: {
                                    Authorization: "Bearer ".concat((_getOuiToken = getOuiToken()) === null || _getOuiToken === void 0 ? void 0 : _getOuiToken.value)
                                }
                            }).then(function(res) {
                                return res.json();
                            }).then(function(json) {
                                var _json_errors;
                                if (json.status === 401 && ((_json_errors = json.errors) === null || _json_errors === void 0 ? void 0 : _json_errors[0].message) === 'UNAUTHORIZED') {
                                    global.window.location.reload();
                                } else if (json.token) {
                                    void cacheOuiToken(json.token);
                                } else {
                                    throw new Error('Invalid response for /auth/token');
                                }
                            }).catch(function(e) {
                                Sentry.captureException(e);
                                // retry is 10s
                                runSessionTimeout(10000);
                            });
                        }, Math.min(ms, 5 * 60 * 1000));
                    }
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cacheOuiToken = _this.cacheOuiToken.bind(_this);
                                getOuiToken = _this.getOuiToken.bind(_this);
                                if (!(Platform.OS === 'web')) return [
                                    3,
                                    2
                                ];
                                getMsToTokenExpiry = function getMsToTokenExpiry() {
                                    var token = getOuiToken();
                                    if (!(token === null || token === void 0 ? void 0 : token.expiresAt)) return 0;
                                    var msUntilExpiry = new Date(token.expiresAt).getTime() - new Date().getTime();
                                    return Math.max(msUntilExpiry, 0);
                                };
                                if (!_this.getOuiToken()) return [
                                    2
                                ];
                                if (sessionTimeout) clearTimeout(sessionTimeout);
                                return [
                                    4,
                                    _class_private_field_get(_this, _authStorage).setItem(USER_SESSION_TOKEN_STORAGE_KEY, _class_private_field_get(_this, _ouiToken))
                                ];
                            case 1:
                                _state.sent();
                                runSessionTimeout();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthClient;
}();
export var authClient = new AuthClient();
